// extracted by mini-css-extract-plugin
export default {"articleContainer":"Article_articleContainer__rBonm","articleContent":"Article_articleContent__8VTxE","buttonWrapper":"Article_buttonWrapper__3q2a1","icon":"Article_icon__tDpZs"};